import DistributorList from '_modules/distributor/views/DistributorList.vue';
import DistributorCreate from '_modules/distributor/views/DistributorCreate.vue';
import DistributorEdit from '_modules/distributor/views/DistributorEdit.vue';
import Distributor from './Root.vue';
import moduleMiddleware from '../../../router/middlewares/moduleMiddleware';

export default {
  path: 'distribuidores/',
  component: Distributor,
  name: 'admin-distributor-team',
  beforeEnter: moduleMiddleware('resellers'),
  redirect: '/distribuidores/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-distributor-list',
      component: DistributorList,
    },
    {
      path: 'novo',
      name: 'admin-distributor-new',
      component: DistributorCreate,
    },
    {
      path: ':id',
      name: 'admin-distributor-edit',
      component: DistributorEdit,
    },
  ],
};
